import React, { Component } from 'react';
import { connect } from 'react-redux';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import ExportingData from 'highcharts/modules/export-data';
import moment from 'moment';
//import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css'
import { setGraphBaselineValue, setGraphAnnotationValue } from '../actions/index';
import GraphAnnotation from '../../../containers/graphAnnotation.js';
import GraphPlotline from '../../../containers/graphPlotline.js';
import AnnotationsFactory from 'highcharts/modules/annotations';
import RaisedButton from 'material-ui/RaisedButton';
import JSZip from 'jszip';
import { downloaduploadedDocumentsOnAPICall } from '../../../constants/ApiConstants';
import { getSVG, svgToPng } from '../../../../../actions/utilAction';
import { getTrendData, getTrendLine } from '../../../../../chartUtils/utlis.js';
AnnotationsFactory(Highcharts);
Exporting(Highcharts);
ExportingData(Highcharts);

class SkillAcquisitionGraph extends Component {

    constructor(props) {
        super(props);
        this.state = {
            sliderMaxValue: props.yAxisMaxValue ? props.yAxisMaxValue : 100,
            sliderValue: props.yAxisMaxValue ? props.yAxisMaxValue : 100,
            AnnotationLabel: this.props.dataAnnotationLabel || [],
            BaselineLabel: this.props.dataBaselineLabel || [],
            xAxisDateOption: [],
            chartArray: [],
            programNameArray: [],
            targetNameArray: [],
            tempLabels: [],
            addTempLabels: false,
        };
        //this.onSliderChange = this.onSliderChange.bind(this);
        this.setAnnotationState = this.setAnnotationState.bind(this);
        this.setBaselineState = this.setBaselineState.bind(this);
    }

    componentDidMount = () => {
        this.highchartsHandler();
    }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.dataBaselineLabel !== null && nextProps.dataBaselineLabel !== this.props.dataBaselineLabel) {
            this.setState({
                BaselineLabel: nextProps.dataBaselineLabel
            }, () => this.highchartsHandler());
        }

        if (nextProps.dataAnnotationLabel !== null && nextProps.dataAnnotationLabel !== this.props.dataAnnotationLabel) {
            this.setState({
                AnnotationLabel: nextProps.dataAnnotationLabel
            }, () => this.highchartsHandler());
        }
    }


    // This method will be sent to the child component
    setAnnotationState(AnnotationState) {
        let annotationLabel = this.props.dataAnnotationLabel || [];
        annotationLabel.push(AnnotationState);
        this.setState({
            AnnotationLabel: annotationLabel
        }, () => this.highchartsHandler());

        this.props.setGraphAnnotationValue(this.state.AnnotationLabel);
    }

    // This method will be sent to the child component
    setBaselineState = (newLabels) => {
        // Always append, not overwrite
        this.setState((prevState) => ({
            BaselineLabel: [...prevState.BaselineLabel],
            tempLabels: [...newLabels],
            addTempLabels: true,
        }), () => this.highchartsHandler());
    }

    highchartsHandler = () => {
        let finalData = [];
        let xAxisDateBeforeSorting = [];
        let xAxisDate = [];
        let graphTitle = [];
        let plotLines = [];
        let yAxispaddings = [];
        let xDates = [];
        let targetIds = [];
        let programNames = [];
        let targetNames = [];
        let xDatesObj = {};
        let xAxisLabel = this.props.xAxisName === undefined ? 'Data' : this.props.xAxisName;
        let yAxisLabel = this.props.yAxisName === undefined ? 'Date' : this.props.yAxisName;
        let disableYaxislabel = this.props.disableYaxislabel;
        let disableXaxislabel = this.props.disableXaxislabel;
        let disableLegend = this.props.disableLegend;
        let gridlinesWidth = this.props.hideGridlines ? 0 : 1;
        let displayAverage = this.props.displayAverage;
        let seriesSum = 0;
        let tempLabels = this.state.tempLabels || [];
        let allBaselineLabels = this.state.BaselineLabel || [];
        
        const graphData = this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionGraphs || [];
        const phaseChangeLineData = this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionPhaseChangeLineGraphs || [];

        function getMaxValue(arr){
            if(arr.length){
                let value  = Math.max(...arr);
                return value;    
            }
        }

        function twentyPercentOf(value) {
            return (value * 20) / 100;
        }

        if (graphData.length > 0) {
            graphData.forEach(obj=>{
                if(!targetIds.includes(obj.targetId)){
                    targetIds.push(obj.targetId);
                    programNames.push(obj.programName);
                    targetNames.push(obj.targetName)
                }
            })
            
            
            targetIds.map((targetId, index) => {
                let dataObj = {}
                let targetData = [];
                let filteredGraphDataByTargetId = graphData.filter((op) => op.targetId === targetId)
                .sort((a, b) => new Date(a.dos) - new Date(b.dos));
                const filteredPhaseChangeLineData = phaseChangeLineData.filter((line) => line.skillsAcquisitionTargetId === targetId);
                
                xAxisDateBeforeSorting = [];

                filteredGraphDataByTargetId.forEach((data)=>{
                    xAxisDateBeforeSorting.push(moment(data.dos).format('MM/DD/YYYY'));
                })
                
                xDates.push(xAxisDateBeforeSorting);

                if (this.props.displaySavedPhaseChangeLines) {
                    for (let k = 0; k < filteredPhaseChangeLineData.length; k++) {
                        let lineIndex = xAxisDateBeforeSorting.indexOf(moment(filteredPhaseChangeLineData[k].lineDate).format('MM/DD/YYYY'));
                        if (lineIndex === -1) {
                            xAxisDateBeforeSorting.push(moment(filteredPhaseChangeLineData[k].lineDate).format('MM/DD/YYYY'));
                        }
                    }
                }

                if (this.props.displayPhaseChangeLineForBaseline) {
                    for (let k = 0; k < graphData.length; k++) {
                        if (graphData[k].dateMetBaseline !== '1900-01-01T00:00:00') {
                            let lineIndex = xAxisDateBeforeSorting.indexOf(moment(graphData[k].dateMetBaseline).format('MM/DD/YYYY'));
                            if (lineIndex === -1 && graphData[k].targetId === targetId) {
                                xAxisDateBeforeSorting.push(moment(graphData[k].dateMetBaseline).format('MM/DD/YYYY'));
                            }
                        }
                    }
                }

                if (this.props.displayphaseChangeLineWhenTheGoalWasMastered) {
                    for (let k = 0; k < graphData.length; k++) {
                        if (graphData[k].dateMastered !== '1900-01-01T00:00:00') {
                            let lineIndex = xAxisDateBeforeSorting.indexOf(moment(graphData[k].dateMastered).format('MM/DD/YYYY'));
                            if (lineIndex === -1 && graphData[k].targetId === targetId) {
                                xAxisDateBeforeSorting.push(moment(graphData[k].dateMastered).format('MM/DD/YYYY'));
                            }
                        }
                    }
                }

                xAxisDateBeforeSorting.sort((dateA, dateB) => new Date(dateA) - new Date(dateB));
                xDatesObj[targetId] = xAxisDateBeforeSorting;

                xAxisDate = [];

                for (let j = 0; j < xAxisDateBeforeSorting.length; j++) {
                    xAxisDate[j] = moment(xAxisDateBeforeSorting[j]).format('MM/DD/YYYY');
                }

                if (targetId) {
                    let targetName = '';
                    let goaldata = filteredGraphDataByTargetId;
                    targetData = [];
                    for (let i = 0; i < goaldata.length; i++) {
                        dataObj['name'] = goaldata[i].targetName;
                        dataObj['targetId'] = goaldata[i].targetId;
                        targetName = goaldata[i].targetName;
                        // targetId.push(goaldata[i].targetId);
                        if (xAxisDate.indexOf(moment(goaldata[i].dos).format('MM/DD/YYYY')) > -1) {
                            let index = xAxisDate.indexOf(moment(goaldata[i].dos).format('MM/DD/YYYY'));
                            targetData[index] = goaldata[i].targetData;
                            // targetData.push(goaldata[i].targetData);
                            const filteredTargetData = targetData.filter(value => value !== null);
                            // seriesSum += parseFloat(goaldata[i].targetData);
                            // seriesCount += 1;
                            seriesSum = filteredTargetData;
                        }
                    }

                    for (let j = 0; j < xAxisDate.length; j++) {
                        //if(!targetData[j])
                        if (targetData[j] == undefined || targetData[j] < 0) {
                            targetData[j] = null;
                        }
                    }
                    let length = targetData.length;
                    let totalSeriesSum = targetData.reduce((sum, value) => sum + value, 0);
                    let maxValue = getMaxValue(targetData);
                    if(maxValue<100){
                    let plus20PercOnMaxValue = twentyPercentOf(maxValue);
                    maxValue = maxValue + plus20PercOnMaxValue;
                    }

                    let avgData = {}
                    if (displayAverage && length > 0 && length > 0 && !this.props.showTrendChart) {
                        var seriesAvg = (totalSeriesSum / length).toFixed(2);
                        let avgD = {};
                        let sAvg;

                        if(targetData){    
                            let length = targetData.length;
                            let newArray = new Array(length);
                            sAvg = parseFloat(seriesAvg);
                            let filledArray = newArray.fill(null);
                            filledArray[0] = sAvg;
                            filledArray[newArray.length-1] = sAvg;
                            avgD = filledArray;
                            }
      
                        
                        avgData = {
                            type: 'line',
                            name: 'Average Line',
                            data: avgD,
                            width: 2,
                            marker:{
                                enabled:false
                            },
                            color: 'transparent',
                            dashStyle: 'shortDash',
                        }
                        plotLines.push({
                            color:"#000000",
                            width: 2,
                            value: [sAvg],
                            zIndex: 4,
                            dashStyle: 'Dash',
                            label: {
                              text: sAvg && sAvg != 0 ? `${sAvg} Avg`:'',
                              align: 'right',
                              x: 0,
                              y: -10
                          }
                        });
                        yAxispaddings.push(maxValue);
                        dataObj['data'] = targetData;
                        finalData.push([avgData,dataObj]);
                        graphTitle.push(targetName);

                    }else{
                        yAxispaddings.push(maxValue);
                        dataObj['data'] = targetData;
                    finalData.push([dataObj]);
                    graphTitle.push(targetName);
                    }
                }
            })

            // add tempLabels to allBaselineLabels
            if (tempLabels && tempLabels.length > 0 && this.state.addTempLabels) {
                for (let k = 0; k < phaseChangeLineData.length; k++) {
                    let targetId = phaseChangeLineData[k].skillsAcquisitionTargetId;
                    for (let index = 0; index < tempLabels.length; index++) {
                        let lineIndex = xDatesObj[targetId] && xDatesObj[targetId].indexOf(moment(tempLabels[index].tempDate).format('MM/DD/YYYY'));
                        const exists = allBaselineLabels.some((label) => label.skillsAcquisitionTargetId === targetId && label.key === tempLabels[index].label.text);
                        if (lineIndex !== -1 && !exists) {
                            let label = {
                                id: 'plotLine_' + Math.random(),
                                value: Number(lineIndex),
                                color: '#000000',
                                width: 2,
                                lineIndex: lineIndex,
                                key: tempLabels[index].label.text,
                                skillsAcquisitionTargetId: targetId,
                                date: tempLabels[index].tempDate,
                                dashStyle: tempLabels[index].dashStyle,
                                label: tempLabels[index].label,
                                events: {
                                    dblclick: function (e) {
                                        this.axis.removePlotLine(this.id)
                                    }
                                }
                            };
                            allBaselineLabels.push(label);
                        }
                    }
                }
                this.setState({
                    addTempLabels: false,
                })
            }


            if (this.props.phaseChangeLineDataFlag && this.props.phaseChangeBaselineDataFlag && this.props.phaseChangeMasteredlineDataFlag && !this.props.displaySavedPhaseChangeLines && !this.props.displayPhaseChangeLineForBaseline && !this.props.displayphaseChangeLineWhenTheGoalWasMastered) {
                this.setState({ BaselineLabel: [] });
                if (tempLabels.length === 0) {
                    allBaselineLabels = [];
                }
            }

            if (this.state.BaselineLabel && (this.state.BaselineLabel[0] === undefined || this.state.BaselineLabel[0] !== 'undefined')) {
                this.setState({ BaselineLabel: [] });
                if (tempLabels.length === 0) {
                    allBaselineLabels = [];
                }
            }
            if (this.props.phaseChangeLineDataFlag && xAxisDate.length > 0 && this.props.displaySavedPhaseChangeLines) {
                let BaselineState = [];
                
                for (let k = 0; k < phaseChangeLineData.length; k++) {
                    let targetId = phaseChangeLineData[k].skillsAcquisitionTargetId
                    let lineIndex = targetId !== 0 && xDatesObj[targetId] ? xDatesObj[targetId].indexOf(moment(phaseChangeLineData[k].lineDate).format('MM/DD/YYYY')): -1;
                    if (Number(lineIndex) >= 0 && phaseChangeLineData[k].lineLabel) {
                        let label = {
                            id: 'plotLine_' + Math.random(),
                            value: Number(lineIndex),
                            color: '#000000',
                            width: 2,
                            lineIndex: lineIndex,
                            key: phaseChangeLineData[k].lineLabel,
                            skillsAcquisitionTargetId: phaseChangeLineData[k].skillsAcquisitionTargetId,
                            date:phaseChangeLineData[k].lineDate,
                            dashStyle: phaseChangeLineData[k].lineTypeName,
                            label: {
                                text: phaseChangeLineData[k].lineLabel
                            },
                            events: {
                                dblclick: function (e) {
                                    this.axis.removePlotLine(this.id)
                                }
                            }
                        };

                        BaselineState.push(label);
                        allBaselineLabels.push(label);
                    }
                }

                this.props.setPhaselineState(false);
            }
            else if (this.props.phaseChangeLineDataFlag && xAxisDate.length > 0 && !this.props.displaySavedPhaseChangeLines && this.state.BaselineLabel && this.state.BaselineLabel.length > 0) {
                for (let k = 0; k < phaseChangeLineData.length; k++) {
                    var indexValue = this.state.BaselineLabel.findIndex(function (data, index) {
                        if (data.key === phaseChangeLineData[k].lineLabel)
                            return true;
                    });
                    if (indexValue !== -1)
                        this.state.BaselineLabel.splice(indexValue, 1);
                }
                this.props.setPhaselineState(false);
                this.props.setGraphBaselineValue(this.state.BaselineLabel);
            }


            if (this.props.phaseChangeBaselineDataFlag && xAxisDate.length > 0 && this.props.displayPhaseChangeLineForBaseline) {
                let phaseChangeBaselineData = this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionGraphs;
                let BaselineState = this.state.BaselineLabel;
                for (let k = 0; k < phaseChangeBaselineData.length; k++) {
                    if (phaseChangeBaselineData[k].dateMetBaseline != '1900-01-01T00:00:00') {
                        let lineIndex = xDatesObj[phaseChangeBaselineData[k].targetId.toString()] && xDatesObj[phaseChangeBaselineData[k].targetId.toString()].indexOf(moment(phaseChangeBaselineData[k].dateMetBaseline).format('MM/DD/YYYY'));
                        var indexValue = allBaselineLabels.findIndex(function (data, index) {
                            if (data.key === 'Baseline' && data.skillsAcquisitionTargetId === phaseChangeBaselineData[k].targetId)
                                return true;
                        });  

                        if (indexValue === -1 && Number(lineIndex) >= 0) {
                            let label = {
                                id: 'plotLine_' + Math.random(),
                                value: Number(lineIndex),
                                date: phaseChangeBaselineData[k].dateMetBaseline,
                                color: '#000000',
                                width: 2,
                                key: 'Baseline',
                                lineIndex: lineIndex,
                                dashStyle: phaseChangeBaselineData[k].baselineTypeName,
                                skillsAcquisitionTargetId: phaseChangeBaselineData[k].targetId,
                                label: {
                                    text: 'Baseline',
                                }
                            };

                            BaselineState.push(label);
                            allBaselineLabels.push(label);
                        }
                    }
                }

                this.props.setBaselineState(false);
            }
            else if (this.props.phaseChangeBaselineDataFlag && xAxisDate.length > 0 && !this.props.displayPhaseChangeLineForBaseline && this.state.BaselineLabel && this.state.BaselineLabel.length > 0) {
                let phaseChangeBaselineData = this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionGraphs;
                for (let k = 0; k < phaseChangeBaselineData.length; k++) {
                    if (phaseChangeBaselineData[k].dateMetBaseline != '1900-01-01T00:00:00' && k === 0) {
                        var indexValue = this.state.BaselineLabel.findIndex(function (data, index) {
                            if (data.key === 'Baseline')
                                return true;
                        });
                        if (indexValue !== -1)
                            this.state.BaselineLabel.splice(indexValue, 1);
                    }
                }

                this.props.setBaselineState(false);
                this.props.setGraphBaselineValue(this.state.BaselineLabel);
            }

            if (this.props.phaseChangeMasteredlineDataFlag && xAxisDate.length > 0 && this.props.displayphaseChangeLineWhenTheGoalWasMastered) {
                let phaseChangeMasteredlineData = this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionGraphs;
                let BaselineState = this.state.BaselineLabel;
                for (let k = 0; k < phaseChangeMasteredlineData.length; k++) {
                    if (phaseChangeMasteredlineData[k].dateMastered != '1900-01-01T00:00:00') {
                        let lineIndex = xDatesObj[phaseChangeMasteredlineData[k].targetId.toString()] && xDatesObj[phaseChangeMasteredlineData[k].targetId.toString()].indexOf(moment(phaseChangeMasteredlineData[k].dateMastered).format('MM/DD/YYYY'));
                        var indexValue = allBaselineLabels.findIndex(function (data, index) {
                            if (data.key === 'Mastered' && data.skillsAcquisitionTargetId === phaseChangeMasteredlineData[k].targetId)
                                return true;
                        });
                        if (indexValue === -1 && Number(lineIndex) >= 0) {
                            let label = {
                                id: 'plotLine_' + Math.random(),
                                value: Number(lineIndex),
                                date: phaseChangeMasteredlineData[k].dateMastered,
                                color: '#000000',
                                width: 2,
                                key: "Mastered",
                                dashStyle: phaseChangeMasteredlineData[k].masteredlineTypeName,
                                skillsAcquisitionTargetId: phaseChangeMasteredlineData[k].targetId,
                                label: {
                                    text: "Mastered"
                                }
                            };

                            BaselineState.push(label);
                            allBaselineLabels.push(label);
                        }
                    }
                }
                this.props.setMasteredlineState(false);
            }
            else if (this.props.phaseChangeMasteredlineDataFlag && xAxisDate.length > 0 && !this.props.displayphaseChangeLineWhenTheGoalWasMastered && this.state.BaselineLabel && this.state.BaselineLabel.length > 0) {
                let phaseChangeMasteredlineData = this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionGraphs;
                //let BaselineState = this.state.BaselineLabel;  

                for (let k = 0; k < phaseChangeMasteredlineData.length; k++) {
                    if (phaseChangeMasteredlineData[k].dateMastered != '1900-01-01T00:00:00' && k === 0) {
                        var indexValue = this.state.BaselineLabel.findIndex(function (data, index) {
                            if (data.key === 'Mastered')
                                return true;
                        });
                        if (indexValue !== -1)
                            this.state.BaselineLabel.splice(indexValue, 1);
                    }
                }

                this.props.setMasteredlineState(false);
                this.props.setGraphBaselineValue(this.state.BaselineLabel);
                // this.setBaselineState(BaselineState);  
            }

        }

        if (xDates.length && this.state.xAxisDateOption.length !== xDates.flat().length) {
            // Flatten all xDates arrays, remove duplicates, and sort
            const allDates = Array.from(
                new Set(xDates.flat())
            ).sort((a, b) => new Date(a) - new Date(b));

            const xAxisDateOption = allDates.map((d, i) => ({
                id: i,
                value: d.toString()
            }));

            this.setState({ xAxisDateOption }, () => {
                this.setState({});
            });
        }
        yAxispaddings.reverse();
        graphTitle.reverse();
        plotLines.reverse();
        finalData.reverse();
        xDates.reverse();

        function formatSecondsToDate(seconds) {
            const date = new Date(new Date(seconds).toUTCString());
            let day = date.getUTCDate();
            let month = date.getUTCMonth() + 1;
            let year = date.getUTCFullYear();
      
            let formattedMonth = month < 10 ? `0${month}` : `${month}`;
            let formattedDay = day < 10 ? `0${day}` : `${day}`;
      
            let formattedDate = `${formattedMonth}/${formattedDay}/${year}`;
            return formattedDate;
          }
      
          function modifyMulArrToSingleWithYAxis(arr,length,type){
              let updatedArr = [];
              if(type=="trendline" && arr.length){
                let emptyArry = new Array(length).fill(null);
                emptyArry[0] = parseFloat(arr[0][1].toFixed(2));
                emptyArry[length-1] = parseFloat(arr[1][1].toFixed(2));
                updatedArr = emptyArry;
              }else if(arr.length){
                for(let i=0;i<length;i++){
                  if(arr[i] && arr[i][1] != null && arr[i][1] != undefined){
                    updatedArr.push(parseFloat(arr[i][1].toFixed(2)))
                  }else {
                    updatedArr.push(null);
                  }
                }
              }
              return updatedArr;
        }
        
        let chartData = [];
        if(this.props.dataAnalytics != null && this.props.dataAnalytics.DCPatientSkillAcqGraphData != null && this.props.dataAnalytics.DCPatientSkillAcqGraphData.data && this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionGraphs && this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionGraphs.length > 0) {
            let graphHoursData = this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionGraphs;
            if(this.props.showTrendChart){
              chartData = finalData.map((c,i)=>{
                let gfData = graphHoursData.filter(d=>d.targetId === c[0].targetId);
                let trndSData = getTrendData(gfData,"targetData","dos")
                let trndSLine = getTrendLine(trndSData);
                let trndData = modifyMulArrToSingleWithYAxis(trndSData,trndSData.length)
                let trndLine = modifyMulArrToSingleWithYAxis(trndSLine,trndSData.length,"trendline")
                xAxisDate = trndSData.map(([a,b])=>formatSecondsToDate(a));
                let newC = {...c,data:trndData};

                let singleAvgLength = trndData.length;
                let totalAvgTrndData = trndData.reduce((acc, curr) => {
                    return acc + curr ;
                },0)
               
                let sAvg;
                let avgData = {}
                if (displayAverage && singleAvgLength > 0 && singleAvgLength > 0 && this.props.showTrendChart){
                    var seriesAvg = (totalAvgTrndData / singleAvgLength).toFixed(2);
                    let avgD = {};
                    
                    if(trndData){    
                        let length = trndData.length;
                        let newArray = new Array(length);
                        sAvg = parseFloat(seriesAvg);
                        let filledArray = newArray.fill(null);
                        filledArray[0] = sAvg;
                        filledArray[newArray.length-1] = sAvg;
                        avgD = filledArray;
                    }   
                    avgData = {
                            type: 'line',
                            name: 'Average Line',
                            data: avgD,
                            width: 2,
                            marker:{
                                enabled:false
                            },
                            color: 'transparent',
                            dashStyle: 'shortDash',
                        }
                    plotLines.push({
                        color:"#000000",
                        width: 2,
                        value: [sAvg],
                        zIndex: 4,
                        dashStyle: 'Dash',
                        label: {
                          text: sAvg && sAvg != 0 ? `${sAvg} Avg`:'',
                          align: 'right',
                          x: 0,
                          y: -10
                      }
                    });   
                }
                return [
                    newC,
                    avgData,
                    {
                
                        type: 'line',
                        name: 'Trend Line',
                        data: trndLine,
                        value: 454,
                        width: 2,
                        marker: {
                            enabled: false
                        },
                        dashStyle: 'longdash',
                        color:"#000000"
                      }
                ]
              })
            }
          }

    
        ////////////////////////////////////


        Highcharts.setOptions({
            colors: ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000']
        });

        let targetId1 = [];
        let chartArray = [];
        let arrIndex = 0;
        let phaseChangeLineDataId = phaseChangeLineData.map(ele=>ele.skillsAcquisitionTargetId)

        // set BaselineLabel state as all baseline labels
        this.setState({
            BaselineLabel: allBaselineLabels,
        });

        // let programNameArray = [];
        const targetIdArray = finalData.map(item => item[0].targetId);
        finalData.length &&
            finalData.map((obj, index) => {
                // if (targetId1.indexOf(obj.targetId) === -1) {
                    const filteredBaselineLabels = allBaselineLabels.filter(
                        (label) => label.skillsAcquisitionTargetId === targetIdArray[index] || label.skillsAcquisitionTargetId === null
                    );

                    let chart = null;
                    targetId1.push(obj.targetId);
                    // programNameArray.push(obj.programName);
                    // targetNameArray.push(obj.targetName);
                    Highcharts.chart(`analyticsDataDiv[${index}]`, {

                        title: {
                            text: `<b>${graphTitle[arrIndex]}</b>`,
                        },
                        annotations: this.state.AnnotationLabel,
                        yAxis: {
                            gridLineWidth: gridlinesWidth,
                            minorGridLineWidth: gridlinesWidth,
                            title: {
                                text: `<b>${xAxisLabel}</b>`
                            },
                            labels: {
                                enabled: disableYaxislabel
                            },
                            max: yAxispaddings[index],
                            min: 0,
                            max: yAxispaddings[index],
                            // --------------------------------
                            plotLines: plotLines[index] && [plotLines[index]],
                        //    ---------------------------------------
                            //height: '50%',
                            // lineWidth: 2,
                        },
                        legend: {
                            align: 'left',
                            verticalAlign: 'bottom',
                            useHTML: true,
                            enabled: disableLegend,
                            reversed: false,
                            //itemWidth:260,
                            itemStyle: {
                                'font-size': '14px',
                                'letter-spacing': '0',
                                'line-height': '17px',
                                'text-align': 'center',
                                "textOverflow": "ellipsis"
                            },
                        },
                        xAxis: {
                            title: {
                                text: `<b>${yAxisLabel}</b>`,
                            },
                            tickLength: 0,
                            categories: xDates[index],
                            labels: {
                                enabled: disableXaxislabel
                            },
                            plotLines: filteredBaselineLabels,
                        },

                        credits: {
                            enabled: false
                        },

                        plotOptions: {
                            series: {
                                cursor: 'pointer',
                                connectNulls: true,
                                //connectNulls: this.state.BaselineLabel.length > 0 ? false : true,
                                fillOpacity: 0.6,
                                label: {
                                    connectorAllowed: false
                                },
                                dataLabels: {
                                    enabled: false
                                },
                                events: {
                                    legendItemClick: function () {
                                        return false
                                    }
                                },
                                marker: {
                                    enabled: true
                                }
                            }
                        },

                        // series: [finalData[arrIndex]],
                        // -------------------------------------------
                        series: this.props.showTrendChart ?
                          chartData[arrIndex] :
                          finalData[arrIndex],
                        // ----------------------------------------------

                        responsive: {
                            rules: [{
                                condition: {
                                    maxWidth: 500
                                },
                                chartOptions: {
                                    legend: {
                                        layout: 'horizontal',
                                        align: 'center',
                                        verticalAlign: 'bottom',
                                        enabled: disableLegend
                                    }
                                }
                            }]
                        },

                        navigation: {
                            buttonOptions: {
                                verticalAlign: 'top',
                                x: -100
                            }
                        },

                        lang: {
                            contextButtonTitle: 'Click to open'
                        },

                        exporting: {
                            enabled: false
                        }
                    });

                    chart = Highcharts.chart(`analyticsDataDiv[${index}]`, {

                        title: {
                            text: `<b>${graphTitle[arrIndex]}</b>`,
                        },
                        annotations: this.state.AnnotationLabel,
                        yAxis: {
                            gridLineWidth: gridlinesWidth,
                            minorGridLineWidth: gridlinesWidth,
                            title: {
                                text: `<b>${xAxisLabel}</b>`
                            },
                            labels: {
                                enabled: disableYaxislabel
                            },
                            max: yAxispaddings[index],
                            min: 0,
                            max: yAxispaddings[index],
                            // -------------------------------------
                            plotLines: plotLines[index] && [plotLines[index]]
                            // --------------------------------------
                            //height: '50%',
                            // lineWidth: 2,
                        },
                        legend: {
                            align: 'left',
                            verticalAlign: 'bottom',
                            useHTML: true,
                            enabled: disableLegend,
                            reversed: false,
                            //itemWidth:260,
                            itemStyle: {
                                'font-size': '14px',
                                'letter-spacing': '0',
                                'line-height': '17px',
                                'text-align': 'center',
                                "textOverflow": "ellipsis"
                            },
                        },
                        xAxis: {
                            type: this.props.showTrendChart && 'datetime',
                            title: {
                                text: `<b>${yAxisLabel}</b>`,
                            },
                            tickLength: 0,
                            // ----------------------------------
                            categories:  xDates[index],
                            labels: {
                                // rotation: this.props.showTrendChart && -45,
                                // formatter: this.props.showTrendChart && function() {
                                //     return Highcharts.dateFormat('%m/%d/%Y', this.value);
                                // },
                                enabled: disableXaxislabel
                            },
                            // ---------------------
                            plotLines: filteredBaselineLabels
                        },

                        credits: {
                            enabled: false
                        },

                        plotOptions: {
                            series: {
                                cursor: 'pointer',
                                connectNulls: true,
                                //connectNulls: this.state.BaselineLabel.length > 0 ? false : true,
                                fillOpacity: 0.6,
                                label: {
                                    connectorAllowed: false
                                },
                                dataLabels: {
                                    enabled: false
                                },
                                events: {
                                    legendItemClick: function () {
                                        return false
                                    }
                                },
                                marker: {
                                    enabled: true
                                }
                            }
                        },

                        // series: [finalData[arrIndex]],
                        // ------------------------------
                        series: this.props.showTrendChart ?  chartData[arrIndex] :finalData[arrIndex],
                        // -----------------------------------

                        responsive: {
                            rules: [{
                                condition: {
                                    maxWidth: 500
                                },
                                chartOptions: {
                                    legend: {
                                        layout: 'horizontal',
                                        align: 'center',
                                        verticalAlign: 'bottom',
                                        enabled: disableLegend
                                    }
                                }
                            }]
                        },

                        navigation: {
                            buttonOptions: {
                                verticalAlign: 'top',
                                x: -100
                            }
                        },

                        lang: {
                            contextButtonTitle: 'Click to open'
                        },

                        exporting: {
                            enabled: false
                        }
                    });

                    arrIndex = arrIndex + 1;
                    chartArray.push(chart);
                // }
                
            });
        this.setState({ chartArray: chartArray });
        this.setState({ programNameArray: programNames.reverse(), targetNameArray: targetNames.reverse() });
    }

    BatchExportToPDF = () => {

        var zip = new JSZip();
        let svgArray = [];
        //var svg1 = getSVG([chart1, chart2]);
        this.state.chartArray.forEach((value, index) => {
            var svg2 = getSVG([this.state.chartArray[index]]);
            //svgArray.push(svg1);
            svgArray.push(svg2);
        });

        let promises = [];
        for (let i = 0; i < svgArray.length; i++) {
            promises.push(svgToPng(svgArray[i], 0, 0));
        }
        Promise.all(promises).then((pngArr) => {
            if (pngArr.length) {
                //let count = 1;
                let i = 0;
                pngArr.forEach((data) => {
                    var src = data.substr(data.indexOf(',') + 1);
                    // zip.file('chart' + count + '.png', src, {
                    zip.file(this.state.programNameArray[i].replace(' ', '_') + '_' + this.state.targetNameArray[i].replace(' ', '_') + '_' + i.toString() + '.png', src, {
                        base64: true
                    });
                    //count++;
                    i++;
                });
                zip.generateAsync({
                    type: "blob"
                }).then(function (blob) { // 1) generate the zip file
                    // saveAs(blob, "charts.zip"); // 2) trigger the download
                    downloaduploadedDocumentsOnAPICall(blob, "SkillAcquisitionGraphs.zip");
                }, function (err) {
                    console.log("error :", err);
                });
            }
        });
    };

    renderData() {
        let targetIds = []

        if (this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionGraphs.length > 0) {
            const graphData = this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionGraphs;
            graphData.forEach(obj=>{
                if(!targetIds.includes(obj.targetId)){
                    targetIds.push(obj.targetId);
                }
            })
        }
        return targetIds && targetIds.map((targetId,index)=>{
            return (
                <div id={`analyticsDataDiv[${index}]`} style={{ height: '500px' }} key={index} />
            );
        })
    };

    render() {
        return (
            <div className='row'>
                <div className='col-sm-11'>
                    {this.state.xAxisDateOption.length > 0 ?
                        <div className='row'>
                            <div className='col-sm-3'><GraphAnnotation setAnnotationState={this.setAnnotationState} xAxisDateOption={this.state.xAxisDateOption} /></div>
                            <div className='col-sm-3'><GraphPlotline setBaselineState={this.setBaselineState} xAxisDateOption={this.state.xAxisDateOption} /></div>
                            <div className='col-sm-3'>
                                <div className='row'>
                                    <div className="col-12 col-sm-12 col-md-12 btn_lft reset-btn claims_filter mt-20">
                                        <RaisedButton className="grey_btn" type="Submit" primary={true} onTouchTap={(e) => this.BatchExportToPDF(e)} >Download all Graphs</RaisedButton>
                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-6'></div>
                        </div>
                        : null}
                    {this.renderData()}
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        dataAnalytics: state.dcSkillAcquisitionBatchGraph,
        dataAnnotationLabel: state.dcSkillAcquisitionBatchGraph.AnnotationLabel || [],
        dataBaselineLabel: state.dcSkillAcquisitionBatchGraph.BaselineLabel || [],
    };
}

export default connect(mapStateToProps, { setGraphBaselineValue, setGraphAnnotationValue })(SkillAcquisitionGraph)


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollectionBatchGraph/SkillAcuisitionGraph/SkillAcquisitionGraph.js